import React from "react";
import filterConnect from "../../../../common/hoc/filterConnect";
import { Form, Input, Select } from "antd";
const Performer = ({ form, disabled, performers, additionalComponent }) => {
  const { getFieldDecorator, getFieldValue } = form;

  const performer =
    performers &&
    performers.filter(performer =>
      performer.companyId === getFieldValue("performer") ? performer : null
    )[0];

  return (
    <>
      <div
        className="offer-card__item double-margin"
        style={
          (additionalComponent && { display: "flex", alignItems: "center" }) ||
          {}
        }
      >
        <span className="label">Исполнитель:</span>
        <Form.Item hidden>
          {getFieldDecorator("performerName", {
            initialValue:
              (performer && performer.nameLegal) ||
              (performer &&
                performer.lastname &&
                performer.name &&
                `ФЛ, ${performer.lastname} ${
                  performer.name && performer.name[0]
                    ? `${performer.name[0]}.`
                    : ""
                } ${
                  performer.patronymic && performer.patronymic[0]
                    ? `${performer.patronymic[0]}.`
                    : ""
                }`)
          })(<Input />)}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("performer", {
            // initialValue: performers && performers[0] ? performers[0].companyId : null,
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(
            <Select
              placeholder="Выберите исполнителя"
              showSearch
              getPopupContainer={trigger => trigger.parentNode}
              style={{ width: 368 }}
              disabled={disabled}
              onChange={(_, options) => {
                form.setFieldsValue({ performerName: options.props.children });
              }}
            >
              {performers &&
                performers.map(item => {
                  return (
                    <Select.Option key={item.companyId} value={item.companyId}>
                      {item.subject && item.subject.subjectKey === "physical"
                        ? `ФЛ, ${item.lastname} ${item.name} ${
                            item.patronymic ? item.patronymic : ""
                          }`
                        : item.nameLegal}
                    </Select.Option>
                  );
                })}
            </Select>
          )}
        </Form.Item>
        {additionalComponent && additionalComponent}
      </div>
    </>
  );
};

export default filterConnect(Performer, ["performers"]);
